import styled from 'styled-components';

export const Container = styled.div`
  // @media screen and (max-width: 1023px) {
  //   padding: 1rem !important;
  // }
`;
